export enum BlockingType {
    UTILISATION = 'UTILISATION',
    DROPOUT = 'DROPOUT',
    AGGREGATE = 'AGGREGATE',
    INTRODUCE = 'INTRODUCE',
    UPD = 'UPD',
    CUSTOMS_DECLARATION = 'CUSTOMS_DECLARATION',
    RECEIVING = 'RECEIVING',
    AGGREGATE_HIGH_LEVEL = 'AGGREGATE_HIGH_LEVEL',
    MOVING = 'MOVING',
    RETURN_GOODS = 'RETURN_GOODS',
    REMARKING = 'REMARKING',
    BLOCKING = 'BLOCKING',
    TRANSFER_DOCUMENT = 'TRANSFER_DOCUMENT',
}

export enum BlockingDocumentStatus {
    NEW = 'NEW',
    CREATED = 'CREATED',
    DECLINED = 'DECLINED',
    APPROVED = 'APPROVED',
    PROCESSED = 'PROCESSED',
    IN_PROGRESS = 'IN_PROGRESS',
    DRAFT = 'DRAFT',
    UNDER_APPROVAL = 'UNDER_APPROVAL',
    RETURNED = 'RETURNED',
    APPROVED_FOR_SHIPMENT = 'APPROVED_FOR_SHIPMENT',
    PENDING = 'PENDING',
    CHECK_SUCCESS = 'CHECK_SUCCESS',
    CHECK_FAIL = 'CHECK_FAIL',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED',
    REVIEW = 'REVIEW',
    REJECTED_AUTOMATIC = 'REJECTED_AUTOMATIC',
    CONFIRMED = 'CONFIRMED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
}

export enum BlokcingReason {
    RESERVED = 'RESERVED',
    EXPIRED = 'EXPIRED',
    PRODUCT_NON_COMPLIANCE = 'PRODUCT_NON_COMPLIANCE',
    SUSPICION = 'SUSPICION',
    REGULATORY_ACTION = 'REGULATORY_ACTION',
}

export enum BlockingScopes {
    ALL = 'ALL',
    APPLY = 'APPLY',
    AGGREGATE = 'AGGREGATE',
    INTRODUCE = 'INTRODUCE',
    RETURN = 'RETURN',
    MOVE = 'MOVE',
    SHIP = 'SHIP',
    RECEIVE = 'RECEIVE',
    RETAIL_SALE = 'RETAIL_SALE',
    REMARK = 'REMARK',
    DISAGGREGATE = 'DISAGGREGATE',
}

export interface BlockingFormData {
    reason: string;
    scope: string;
    supportingDocumentNumber?: string;
    supportingDocumentDate?: Date | null;
    comment?: string;
    attachmentFiles?: File[];
    documentId: string;
}

export enum BlockingSourceFormation {
    USER_FORM = 'USER_FORM',
    API_INTEGRATION = 'API_INTEGRATION',
    SYSTEM_ACTION = 'SYSTEM_ACTION',
}

export enum BlockingFormationProcess {
    MANUAL = 'MANUAL',
    API = 'API',
    AUTOMATIC = 'AUTOMATIC',
}

export enum UnblockingReason {
    REASON_ELIMINATED = 'REASON_ELIMINATED',
    COMPLIANCE_CONFIRMED = 'COMPLIANCE_CONFIRMED',
    FALSE_POSITIVE = 'FALSE_POSITIVE',
    AUTHORITY_DECISION = 'AUTHORITY_DECISION',
    OTHER = 'OTHER',
}

export interface ProductBlockingCodesRequest {
    paging: {
        pageSize: number;
        pageRef: string | null;
    };
    type: BlockingType;
    createdAt: string;
    docOrOwner: string;
    filters: [
        {
            id: string;
            value: string;
        },
    ];
    sortings: [
        {
            id: string;
            desc: boolean;
        },
    ];
}

export interface ProductBlockingCodesResponseData {
    reportId: string;
    status: BlockingDocumentStatus;
    createdAt: string;
    reason: BlokcingReason;
    scopes: BlockingScopes[];
    sourceFormation: BlockingSourceFormation;
    formationProcess: BlockingFormationProcess;
    codesCount: number;
    operator: string;
    organizationName: string;
    participantTin: string;
    supportingDocumentNumber: string;
    supportingDocumentDate: string;
    comment: string;
}
export interface ProductBlockingCodesResponseRaw {
    nextPageRef: string;
    data: ProductBlockingCodesResponseData[];
}

export type RemoveCodeLockPayload = {
    blockingId: string;
    markingCode: string;
    unblockingReason: UnblockingReason;
    comment: string;
};

export type ProductBlockingTableFilterValue =
    | string
    | {
          left: string;
          right: string;
      };

export interface ProductBlockingTableRequest {
    paging: {
        pageSize: number;
        pageRef: string | null;
    };
    type?: BlockingType;
    createdAt?: string;
    docOrOwner?: string;
    filters: Array<{
        id: string;
        value: ProductBlockingTableFilterValue;
    }>;
    sortings: Array<{
        id: string;
        desc: boolean;
    }>;
}

export interface ProductBlockingTableResponseData {
    nextPageRef: string;
    data: ProductBlockingCodesResponseData[];
}

export interface ProductBlockingTableDictionary {
    status?: string[];
    reason?: string[];
    organizationName?: string[];
    participantTin?: string[];
    sourceFormation?: string[];
    formationProcess?: string[];
}

export interface CreateBlockingDocumentPayload {
    documentId: string;
    codes: string[];
    reason: BlokcingReason;
    scopes: BlockingScopes[];
    supportingDocumentNumber?: string;
    supportingDocumentDate?: string;
    comment?: string;
    attachment?: string[];
}
